<template>
  <tabs @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-nav-classes="icon-white" tab-content-classes="tab-content-padding tab-no-space ">
    <tab-pane label="requested-checkups">
      <template slot="label">
        <i class="now-ui-icons education_paper"></i>
      </template>

      <div class="pb-3" style="height: calc(100% - 60px);overflow: scroll;padding-top:1em">
        <div class="col-12 col-md-12 form-group">
          <el-select class="select-primary" size="large" name="latestStatus" placeholder="Latest Status" v-model="status">
            <el-option class="select-primary" value="" :label="$t('message.All')"></el-option>
            <el-option class="select-primary" value="Pending" :label="$t('message.Pending')"></el-option>
            <el-option class="select-primary" value="Rejected" :label="$t('message.Rejected')"></el-option>
            <el-option class="select-primary" value="Cancelled" :label="$t('message.Cancelled')"></el-option>
            <el-option class="select-primary" value="Scheduled" :label="$t('message.Scheduled')"></el-option>
          </el-select>
        </div>
        <span v-if="checkupRequests && checkupRequests.length > 0">
          <!--          <div class="col-lg-12 col-md-12 col-sm-12" v-for="checkupRequest in checkupRequests" :key="checkupRequest._id">
            <card class="card-stats">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div class="row visit-details details">
                    <div class="col-12 col-md-12">
                      <slot>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-microscope"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{checkupRequest.preferredLab}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clock"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLaborderDatetime(checkupRequest.created)}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-question-circle"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{checkupRequest.latestStatus}}</span>
                          </div>
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats text-center" slot="footer">
                <n-button type="primary" class="btn-padding light mr-2" round @click.native="$store.commit('setState', {stateName: 'bookingReq',stateValue: checkupRequest});$router.push('viewhealthcheckuprequest');">
                  <i slot="label" class="fa fa-eye"></i>
                  {{ $t("message.View") }}
                </n-button>
                <n-button v-if="checkupRequest.latestStatus == 'Pending'" type="primary" class="btn-padding light mr-2" round @click.native="cancelHealthCheckupRequest(checkupRequest)">
                  <i class="now-ui-icons ui-1_simple-remove pr-1"></i>
                  {{ $t("message.Cancel") }}
                </n-button>
              </div>
            </card>
          </div>
          <infinite-loading spinner="waveDots" @infinite="getHealthCheckupRequests">
            <span slot="no-more">{{ $t("message.No more health checkup requests") }}</span>
            <span slot="no-results"></span>
          </infinite-loading> -->

          <div class="col-lg-12 col-md-12 col-sm-12" style="overflow:scroll;">
            <time-line type="simple">
              <!--               <time-line-item inverted badge-icon="now-ui-icons objects_planet" badge-type="danger">
                <span slot="header" class="badge badge-danger">Some Title</span>
                <p slot="content">Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for
                  making
                  my family We just had fun with the “future” theme !!! It was a fun night all together ... The
                  always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.</p>
                <span slot="footer">
                  11 hours ago via Twitter
                </span>
              </time-line-item>

              <time-line-item inverted badge-icon="now-ui-icons shopping_tag-content" badge-type="success">
                <span slot="header" class="badge badge-success">Another One</span>
                <p slot="content">Thank God for the support of my wife and real friends.
                  I also wanted to point out that it’s the first album to go number 1 off of streaming!!!
                  I love you Ellen and also my number one design rule of anything
                  I do from shoes to music to homes is that Kim has to like it....</p>
              </time-line-item> -->

              <time-line-item @click.native="$store.commit('setState', {stateName: 'bookingReq',stateValue: checkupRequest});$router.push('viewhealthcheckuprequest');" v-for="checkupRequest in checkupRequests" :key="checkupRequest._id" inverted :badge-icon="getBadgeIcon(checkupRequest)" :badge-type="checkupRequest.latestStatus == 'Pending'?'info' : ((checkupRequest.latestStatus == 'Rejected' || checkupRequest.latestStatus == 'Cancelled') ? 'danger':'success')">
                <span slot="header" class="badge badge-info" :class="checkupRequest.latestStatus == 'Pending'?'badge-info' : ((checkupRequest.latestStatus == 'Rejected' || checkupRequest.latestStatus == 'Cancelled') ? 'badge-danger':'badge-success')">{{checkupRequest.latestStatus}}</span>
                <span slot="header" class="timeline-header">{{getTimeOrDays(checkupRequest.created)}}</span>
                <template slot="content">
                  <div class="statistics statistics-horizontal">
                    <div class="info info-horizontal">
                      <div class="row visit-details details">
                        <div class="col-12 col-md-12">
                          <slot>
                            <div class="row">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fa fa-microscope"></i>
                                </span>
                              </div>
                              <div class="col-md-8 col-9 pl-0">
                                <span>{{checkupRequest.preferredLab}}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fas fa-box"></i>
                                </span>
                              </div>
                              <div class="col-md-8 col-9 pl-0">
                                <span>{{checkupRequest.healthPackage.name}}</span>
                              </div>
                            </div>
                          </slot>
                        </div>
                      </div>
                    </div>
                  </div>

                </template>
              </time-line-item>
              <infinite-loading spinner="waveDots" @infinite="getHealthCheckupRequests" forceUseInfiniteWrapper="window">
                <span slot="no-more">{{ $t("message.No more health checkup requests") }}</span>
                <span slot="no-results"></span>
              </infinite-loading>

            </time-line>
          </div>
        </span>
        <div class="col-12 text-center pt-2" v-else>{{ $t("message.No health checkup requests") }}</div>
      </div>

      <n-button type="primary" round @click.native="$router.push('requestahc')" style="position: fixed;bottom: 4em;left: 50%;transform: translate(-50%);">
        <i class="now-ui-icons ui-1_simple-add"></i>
        {{ $t("message.Request for Checkup") }}
      </n-button>

    </tab-pane>

    <tab-pane label="scheduled-checkups">
      <template slot="label">
        <i class="fa fa-microscope" />
      </template>
      <div class="pb-3" style="height: calc(100% - 60px);overflow: scroll;padding-top:1em">
        <div class="col-12 col-md-12 form-group">
          <el-select class="select-primary" size="large" name="latestStatus" placeholder="Latest Status" v-model="latestStatusQuery">
            <el-option class="select-primary" value="" :label="$t('message.All')"></el-option>
            <el-option class="select-primary" value="Created" :label="$t('message.Scheduled')"></el-option>
            <el-option class="select-primary" value="Sample Collected" :label="$t('message.Sample collected')"></el-option>
            <el-option class="select-primary" value="Sample Deposited" :label="$t('message.Sample deposited')"></el-option>
            <el-option class="select-primary" value="Report Uploaded" :label="$t('message.Report uploaded')"></el-option>
          </el-select>
        </div>
        <span v-if="scheduledRequests && scheduledRequests.length > 0">
          <div class="col-lg-12 col-md-12 col-sm-12" v-for="scheduledRequest in scheduledRequests" :key="scheduledRequest._id">
            <card class="card-stats">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div class="row visit-details details">
                    <div class="col-12 col-md-12">
                      <slot>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-microscope"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{scheduledRequest.lab}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clock"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLaborderDatetime(scheduledRequest.created)}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-question-circle"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span v-if="scheduledRequest.latestStatus == 'Created'">{{$t('message.Scheduled')}}</span>
                            <span v-else>{{scheduledRequest.latestStatus}}</span>
                          </div>
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats text-center" slot="footer">
                <n-button type="primary" class="btn-padding light mr-2" round @click.native="$store.commit('setState', { stateName: 'scheduledRequest', stateValue: scheduledRequest }); $router.push('viewschedueledhealthcheckuprequest');">
                  <i slot="label" class="fa fa-eye"></i>
                  {{ $t("message.View") }}
                </n-button>
              </div>
            </card>
          </div>
          <infinite-loading spinner="waveDots" @infinite="getScheduledRequests" forceUseInfiniteWrapper="window" style="padding: 20px;">
            <span slot="no-more">{{ $t("message.No more health checkup requests") }}</span>
            <span slot="no-results"></span>
          </infinite-loading>
        </span>
        <div class="col-12 text-center pt-2" v-else>{{ $t("message.No health checkup requests") }}</div>
      </div>

    </tab-pane>
  </tabs>
</template>

<script>
import { TabPane, Tabs, TimeLine, TimeLineItem } from "src/components";
import socket from "@/services/socket";
import moment from "moment";

export default {
  name: "ahc",
  components: {
    TabPane,
    Tabs,
    TimeLine,
    TimeLineItem,
  },
  data() {
    return {
      lab: {},
      getHealthCheckupRequestsExecuting: false,
      getScheduledRequestsExecuting: false,
      checkupRequests: [],
      scheduledRequests: [],
      checkupRequestsPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 4,
      },
      scheduledRequestsPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 4,
      },
      latestStatusQuery: "",
      status: "",
    };
  },
  computed: {
    ahcAppointments() {
      if (this.$store.state.ahcAppointments) {
        return this.$store.state.ahcAppointments.sort((a, b) => {
          return (
            b.appointmentStatus[b.appointmentStatus.length - 1].timestamp -
            a.appointmentStatus[a.appointmentStatus.length - 1].timestamp
          );
        });
      }
    },
  },
  async mounted() {
    await this.getHealthCheckupRequests();
    await this.getScheduledRequests();

    //Socket listeners
    socket.on("healthCheckupRequestReviewed", async (data) => {
      await this.getHealthCheckupRequests();
      await this.getScheduledRequests();
    });
  },
  watch: {
    latestStatusQuery: function () {
      this.getScheduledRequests();
    },
    status: function () {
      this.getHealthCheckupRequests();
    },
  },
  methods: {
    onTabChange(label) {
      this.changeAppHeaderText(label);
    },
    async getHealthCheckupRequests($state) {
      if (!this.getHealthCheckupRequestsExecuting) {
        try {
          this.getHealthCheckupRequestsExecuting = true;
          if (!$state) {
            this.checkupRequests = [];
            this.checkupRequestsPagination = {
              pageNumber: 1,
              totalPages: 0,
              pageSize: 4,
            };
          }
          let query = {
            requestFor: "healthCheckup",
            patientId: this.user.patientId,
            pageNumber: this.checkupRequestsPagination.pageNumber,
            pageSize: this.checkupRequestsPagination.pageSize,
          };
          if (this.status) {
            query["status"] = this.status;
          }
          let response = await this.$store.dispatch(
            "getHealthCheckupRequests",
            query
          );
          if (response.data && response.data.length) {
            this.checkupRequests.push(...response.data);
            this.checkupRequestsPagination.totalPages = response.totalPages;
            this.checkupRequestsPagination.pageNumber += 1;
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
          this.getHealthCheckupRequestsExecuting = false;
        } catch (err) {
          this.getHealthCheckupRequestsExecuting = false;
          console.log(err);
        }
      }
    },
    async getScheduledRequests($state) {
      if (!this.getScheduledRequestsExecuting) {
        try {
          this.getScheduledRequestsExecuting = true;
          if (!$state) {
            this.scheduledRequests = [];
            this.scheduledRequestsPagination = {
              pageNumber: 1,
              totalPages: 0,
              pageSize: 4,
            };
          }
          let query = {
            patientId: this.user.patientId,
            pageNumber: this.scheduledRequestsPagination.pageNumber,
            pageSize: this.scheduledRequestsPagination.pageSize,
          };
          if (this.latestStatusQuery) {
            query["latestStatus"] = this.latestStatusQuery;
          }
          let response = await this.$store.dispatch("getLaborders", query);
          console.log("this.scheduledRequests :", response.data);
          if (response.data && response.data.length) {
            this.scheduledRequests.push(...response.data);
            this.scheduledRequestsPagination.totalPages = response.totalPages;
            this.scheduledRequestsPagination.pageNumber += 1;
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
          this.getScheduledRequestsExecuting = false;
        } catch (err) {
          this.getScheduledRequestsExecuting = false;
          console.log(err);
        }
      }
    },
    getLaborderDatetime(date) {
      let timestamp = Date.parse(date);
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
    },
    getTimeOrDays(date) {
      let timestamp = Date.parse(date);
      let currentTimestamp = moment(new Date());
      let mins = currentTimestamp.diff(timestamp, "minutes");
      if (mins <= 60) {
        if (mins <= 1) {
          return mins + " " + this.$t("message.minute ago");
        } else {
          return mins + " " + this.$t("message.minutes ago");
        }
      } else {
        let hours = currentTimestamp.diff(timestamp, "hours");
        if (hours <= 24) {
          if (hours <= 1) {
            return hours + " " + this.$t("message.hour ago");
          } else {
            return hours + " " + this.$t("message.hours ago");
          }
        } else {
          let days = Math.floor(hours / 24);
          if (days <= 1) {
            return days + " " + this.$t("message.day ago");
          } else {
            return days + " " + this.$t("message.days ago");
          }
        }
      }
    },
    getFormattedDate(timestamp) {
      return moment(Number(timestamp)).format("DD-MM-YYYY");
    },
    viewAppointment(appointment) {
      this.$store.commit("setState", {
        stateName: "selectedAhcAppointment",
        stateValue: appointment,
      });

      if (appointment.latestStatus == "Created") {
        this.$store.commit("setState", {
          stateName: "chatThread",
          stateValue: appointment.careCoordinatorMessages,
        });

        this.$router.push("requestedahc");
      } else {
        this.$router.push("ahcReport");
      }
    },
    checkupRequestStatus(request) {
      if (!request.latestStatus) {
        return this.$t("message.Report Updated");
      } else if (request.latestStatus == "Created") {
        return this.$t("message.Requested");
      } else if (request.latestStatus == "Assigned") {
        return this.$t("message.Booked");
      } else if (request.latestStatus == "reportUpdated") {
        return this.$t("message.Report Uploaded");
      } else {
        return request.latestStatus;
      }
    },
    getBadgeIcon(request) {
      let iconClass = "";
      switch (request.latestStatus) {
        case "Pending":
          iconClass = "far fa-clock";

          // iconClass = "now-ui-icons tech_watch-time";/
          break;
        case "Scheduled":
          iconClass = "now-ui-icons ui-1_calendar-60";
          break;
        case "Rejected":
          iconClass = "now-ui-icons ui-1_simple-remove";
          break;
        case "Cancelled":
          iconClass = "now-ui-icons ui-1_simple-remove";
          break;
      }
      return iconClass;
    },
  },
};
</script>

<style scoped>
.timeline-header {
  float: right;
  font-weight: bold;
}
[dir="rtl"] .timeline-header {
  float: left;
}
/deep/.tab-content {
  height: calc(100% - 68px);
  /* Commented to make absolute positioned elements to be relative to .main-panel */
  /* position: relative; */
}
.content > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}
.status-update-buttons {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.el-timeline {
  padding-left: 2em;
}

/deep/.el-timeline-item__icon {
  color: #18ce0f;
}

/deep/.el-timeline-item__node {
  background: white;
  border: solid 1px #18ce0f;
  padding: 0.8em;
  left: -7px;
}
/deep/.el-timeline-item {
  padding-bottom: 30px;
}

/deep/.el-timeline-item__timestamp {
  font-size: 11px;
}
.laborder-passcode {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5em;
}
/deep/.timeline-panel {
  box-shadow: 0 1px 15px 1px rgb(39 39 39 / 10%) !important;
  width: 85% !important;
}
/deep/ .card-timeline .timeline > li > .timeline-badge {
  width: 35px;
  height: 35px;
  top: 22px;
  margin-inline-start: -18px;
}

/deep/ .card-timeline .timeline > li > .timeline-badge .now-ui-icons {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff !important;
}
/deep/ .card-timeline .timeline > li > .timeline-badge .far {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/.card-timeline .timeline > li > .timeline-badge {
  z-index: 0;
}

/deep/ #requested-checkups .card .card-body {
  padding: 0px 0px 3em 0px;
}
</style>
